import { NavListSeparator } from '@billy/design-system'
import styled from '@emotion/styled'

export const DropdownFooterWrapper = styled.div``

export const Separator = styled(NavListSeparator)``
